import { render, staticRenderFns } from "./tripartiteData.vue?vue&type=template&id=3d87363a&scoped=true"
import script from "./tripartiteData.vue?vue&type=script&lang=js"
export * from "./tripartiteData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d87363a",
  null
  
)

export default component.exports